import React, { Component } from 'react';

export default class Test extends Component {
    render() {
        return (
            <div>
                <h1>Testpage</h1>
            </div>
        );
    }
}
